module.exports = __webpack_public_path__ + "media/images/riders/small/HENRIQUE_AVANCINI-e78b3fef016b93bc9da0c39e7f02821f.png";